<template>
  <div
    ref="viewer"
    style="position: absolute; left: 0; right: 0; top: 0; bottom: 0; height: 1000px"
    data-bind="dxReportViewer: $data"
  ></div>
</template>

<script>
  import ko from 'knockout'
  import 'devexpress-reporting/dx-webdocumentviewer'

  export default {
    name: 'WebDocumentViewer',
    mounted () {
      var viewerOptions = {
        reportUrl: ko.observable('NewTestReport'), // The URL of a report.
        requestOptions: {
          host: process.env.VUE_APP_REPORTS_URI,

          // Use this line for the ASP.NET MVC backend
          // invokeAction: "/WebDocumentViewer/Invoke"
          // Use this line for the ASP.NET Core backend
          invokeAction: 'DXXRDV'
        }
      }
      ko.applyBindings(viewerOptions, this.$refs.viewer)
    },
    beforeDestroy () {
      ko.cleanNode(this.$refs.viewer)
    }
  }
</script>
